import styled from 'styled-components';

import {ContentContainer} from 'components/ui-kit/PageComponents';
import {breakpoint, colors} from 'theme';

export const Wrapper = styled.div`
    width: calc(100% + 30px);
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    margin-left: -15px;
    margin-bottom: -30px;
    border-top: 1px solid ${colors.textMuted};

    @media (min-width: ${breakpoint.tablet}) {
        width: calc(100% + 60px);
        margin-left: -30px;
    }
`;

export const Container = styled(ContentContainer)`
    padding: 0;
`;
